import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getIcon } from '../../util/icons';

import ReactTooltip from 'react-tooltip';

import {
  getSellingCompetency,
  sellingCompetencies,
  getCompetencyScoreFromQuestionsAndResponses,
  getCoachabilityScoreFromQuestionsAndResponses,
  getTierFromScore,
  getScoreDescriptions,
  getPredictiveSkillsReviewScoresFromReviewData,
} from '../../util';

import {
  ScoredCriticalExpertiseItemsSelector
} from '../../selectors';

class ReviewSnapshot extends Component {

  state = {
    currentlyHighlighting: this.props.priorReview ? 'mostImproved' : 'topCompetencies'
  }

  componentDidUpdate(prevProps, prevState){
    //on review change, revert currently highlighting
    if(prevProps.review !== this.props.review){
      this.setState({
        currentlyHighlighting: this.props.priorReview ? 'mostImproved' : 'topCompetencies'
      });
    }
  }

  scores(){
    return getPredictiveSkillsReviewScoresFromReviewData(this.props.salesCompetencyReviewItems, this.props.scoredCriticalExpertiseItems, this.props.review, this.props.priorReview);
  }
  renderScoresRow(){

    const {
      overallScore,
      overallTier,
      overallDelta,
      competencyScore,
      competencyTier,
      competencyDelta,
      expertiseScore,
      expertiseTier,
      expertiseDelta,
      coachabilityScore,
      coachabilityTier,
      coachabilityDelta,
    } = this.scores();

    return (
      <div className="scores-row">
        <div className={`score overall ${overallDelta ? 'has-diff' : ''}`}>
          <div className="score-name">Weighted<br/>Total<br/><small>100%</small></div>
          <div className={`dial tier-${overallTier} large-ring`} style={{width: '120px', height: '120px'}}>
            <div className="dial__progress" data-percent={overallScore}></div>
            <div className="dial__content" style={{lineHeight: '95px', fontSize: '32px'}}>{overallScore}</div>
            {!!overallDelta &&
              <div className="diff-amount">{overallDelta > 0 ? '+' : ''}{overallDelta}</div>
            }
          </div>
        </div>
        <div className={`score competency ${competencyDelta ? 'has-diff' : ''}`}>
          <div className="score-name">Selling<br/>Competencies<br/><small>60%</small></div>
          <div className={`dial tier-${competencyTier} medium-large-ring`} style={{width: '90px', height: '90px', margin: '12px'}}>
            <div className="dial__progress" data-percent={competencyScore}></div>
            <div className="dial__content" style={{lineHeight: '70px', fontSize: '24px'}}>{competencyScore}</div>
            {!!competencyDelta &&
              <div className="diff-amount">{competencyDelta > 0 ? '+' : ''}!!!{competencyDelta}</div>
            }
          </div>
        </div>
        <div className={`score knowledge ${expertiseDelta ? 'has-diff' : ''}`}>
          <div className="score-name">Critical<br/>Expertise<br/><small>25%</small></div>
          <div className={`dial tier-${expertiseTier} medium-large-ring`} style={{width: '90px', height: '90px', margin: '12px'}}>
            <div className="dial__progress" data-percent={expertiseScore}></div>
            <div className="dial__content" style={{lineHeight: '70px', fontSize: '24px'}}>{expertiseScore}</div>
            {!!expertiseDelta &&
              <div className="diff-amount">{expertiseDelta > 0 ? '+' : ''}{expertiseDelta}</div>
            }
          </div>
        </div>
        <div className={`score coachability ${coachabilityDelta ? 'has-diff' : ''}`}>
          <div className="score-name one-word">Coachability<br/><small>15%</small></div>
          <div className={`dial tier-${coachabilityTier} medium-large-ring`} style={{width: '90px', height: '90px', margin: '12px'}}>
            <div className="dial__progress" data-percent={coachabilityScore}></div>
            <div className="dial__content" style={{lineHeight: '70px', fontSize: '24px'}}>{coachabilityScore}</div>
            {!!coachabilityDelta &&
              <div className="diff-amount">{coachabilityDelta > 0 ? '+' : ''}{coachabilityDelta}</div>
            }
          </div>
        </div>
      </div>
    )
  }

  renderCurrentHighlightsList(){

    const { currentlyHighlighting } = this.state;

    const currentlyVisibleHighlights = _.take(this.scores()[currentlyHighlighting], (currentlyHighlighting === 'topCompetencies' || currentlyHighlighting === 'bottomCompetencies' ? 3 : 5));

    console.log('currentlyVisibleHighlights: ', currentlyVisibleHighlights);

    if(_.size(currentlyVisibleHighlights) == 0){
      return 'No results.'
    }
    else if(currentlyHighlighting === 'mostImproved'){

      return (
        <ul className="highlights-ranked-list">
          {_.map(currentlyVisibleHighlights, item => {

            const tooltipId = `highlights-tooltip-for-${item.id}`;
            const tooltip = `${item.name} improved by ${item.delta} points since last review.`;

            return (
              <React.Fragment key={item.id}>
                <li data-tip={tooltip} data-for={tooltipId}>{item.name} <small>+{item.delta}</small></li>
                <ReactTooltip id={tooltipId} effect="solid" place="top" />
              </React.Fragment>
            )
          })}
        </ul>
      )
    }
    else if(currentlyHighlighting === 'topCompetencies' || currentlyHighlighting === 'bottomCompetencies'){
      return (
        <ul className="highlights-ranked-list">
          {_.map(currentlyVisibleHighlights, item => {

            const tooltipId = `highlights-tooltip-for-${item.id}`;
            const tooltip = `${item.name} score (${item.score}) is${item.delta > 0 ? ` an improvement of +${item.delta} since last review.` : (item.delta < 0 ? ` a decline of ${Math.abs(item.delta)} since last review.` : '.')}`;

            return (
              <React.Fragment key={item.id}>
                <li data-tip={tooltip} data-for="highlights-tip">{item.name} <small className={`tier-${item.tier}-bg`}>{item.score}</small></li>
                <ReactTooltip id={tooltipId} effect="solid" place="top" />
              </React.Fragment>
            )
          })}
        </ul>
      )
    }
    else if(currentlyHighlighting === 'underEstimated' || currentlyHighlighting === 'overEstimated'){
      return (
        <ul className="highlights-ranked-list">
          {_.map(currentlyVisibleHighlights, item => {

            const tooltipId = `highlights-tooltip-for-${item.id}`;
            const tooltip = 'something';

            return (
              <React.Fragment key={item.id}>
                <li data-tip={tooltip} data-for="highlights-tip">{item.name} <small>{item.diff > 0 ? '+' : ''}{item.diff}</small></li>
                <ReactTooltip id={tooltipId} effect="solid" place="top" />
              </React.Fragment>
            )
          })}
        </ul>
      )
    }
  }

  getDescriptionFromHighlightingProp(prop){

    const possessivePrefixForRole = this.props.isOwnReview ? 'Your' : `${(this.props.sellerInfo || {}).firstName}\'s`;
    const prefixForRole = this.props.isOwnReview ? 'You' : `${(this.props.sellerInfo || {}).firstName}`;

    if(prop === 'mostImproved'){
      return `${possessivePrefixForRole} Most Improved Abilities`;
    }
    else if(prop === 'topCompetencies'){
      return `${possessivePrefixForRole} Strongest Selling Competencies`;
    }
    else if(prop === 'bottomCompetencies'){
      return `${possessivePrefixForRole} Weakest Selling Competencies`;
    }
    else if(prop === 'overEstimated'){
      return `Abilities ${prefixForRole} Over Estimate${this.props.isOwnReview ? '' : 's'}`;
    }
    else if(prop === 'underEstimated'){
      return `Abilities ${prefixForRole} Under Estimate${this.props.isOwnReview ? '' : 's'}`;
    }
    else{
      return ``;
    }
  }

  render(){

    if(this.props.loadingPredictiveSkillsReviewItems){
      return 'Loading...';
    }

    const {
      currentlyHighlighting
    } = this.state;

    return (
      <div className="sales-competency-review-snapshot">
        <div className="results-section">
          <h6 className="centered">SCORES</h6>
          <div className="section-content scores">
            {this.renderScoresRow()}
          </div>
        </div>
        <div className="results-section">
          <h6>HIGHLIGHTS</h6>
          <div className="section-content highlights">
            <div className="highlights-left">
              <ul>
                {this.props.priorReview &&
                  <li className={`${currentlyHighlighting === 'mostImproved' ? 'active' : ''}`} onClick={() => { this.setState({ currentlyHighlighting: 'mostImproved' }); }}>Most Improved</li>
                }
                <li className={`${currentlyHighlighting === 'topCompetencies' ? 'active' : ''}`} onClick={() => { this.setState({ currentlyHighlighting: 'topCompetencies' }); }}>Top Competencies</li>
                <li className={`${currentlyHighlighting === 'bottomCompetencies' ? 'active' : ''}`} onClick={() => { this.setState({ currentlyHighlighting: 'bottomCompetencies' }); }}>Bottom Competencies</li>
                <li className={`${currentlyHighlighting === 'underEstimated' ? 'active' : ''}`} onClick={() => { this.setState({ currentlyHighlighting: 'underEstimated' }); }}>Hidden Strengths</li>
                <li className={`${currentlyHighlighting === 'overEstimated' ? 'active' : ''}`} onClick={() => { this.setState({ currentlyHighlighting: 'overEstimated' }); }}>Blind Spots</li>
              </ul>
            </div>
            <div className="highlights-right">
              <p className="highlights-description">{this.getDescriptionFromHighlightingProp(currentlyHighlighting)}</p>
              {this.renderCurrentHighlightsList()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    organization: state.organization.data,
    salesCompetencyReviewItems: state.salesCompetencyReviewItems.items,
    loadingPredictiveSkillsReviewItems: state.salesCompetencyReviewItems.loading,
    viewingUser: state.viewingUser.data,
    scoredCriticalExpertiseItems: ScoredCriticalExpertiseItemsSelector(state),
  }
}

export default connect(mapStateToProps, {  })(ReviewSnapshot);



// WEBPACK FOOTER //
// ./src/components/salesCompetencies/reviewSnapshot.js